import {gql} from "@irati/utils/gql"
import fullPayment from "../fragments/fullPayment"

const query = gql`
  mutation PaymentPayByCard($paymentOrderId: ID!, $details: PaymentCardInput!) {
    paymentPayByCard(paymentOrderId: $paymentOrderId, details: $details) {
      ...fullPayment
    }
  }
  ${fullPayment}
`

export const toString = query.loc.source.body

export default query
